import React, { FC, ReactNode } from 'react';
import { Box } from '@rebass/grid';
import Title from '@oberoninternal/travelbase-ds/components/primitive/Title';
import { FormattedMessage } from 'react-intl';
import { CardFragment } from '../generated/graphql';
import styled from 'styled-components';
import Card from './Card';
import Skeleton from 'react-loading-skeleton';

interface Props {
    relatedItems: CardFragment[];
    title?: ReactNode;
    loading?: boolean;
}

const RelatedItems: FC<React.PropsWithChildren<Props>> = ({
    relatedItems,
    title = <FormattedMessage defaultMessage="Laatste nieuws" />,
    loading = false,
}: Props) => (
    <Box pt={[5, 7]} pb={7}>
        <Title variant={'regular'}>{title}</Title>
        <Box pt={5}>
            <Items>
                {!loading
                    ? relatedItems?.map(
                          (relatedItem, key) => relatedItem && <StyledCard item={relatedItem} key={key} />
                      )
                    : Array(4)
                          .fill(null)
                          .map((_, i) => <Skeleton height={300} key={i} />)}
            </Items>
        </Box>
    </Box>
);

export default RelatedItems;

const Items = styled.div`
    display: grid;
    position: relative;
    grid-gap: 3.2rem;
    grid-template-columns: 1fr;

    @media screen and (min-width: ${({ theme }) => theme.mediaQueries.m}) {
        grid-template-columns: 1fr 1fr 1fr;
    }
`;

const StyledCard = styled(Card)``;
